import React, { useState } from 'react';
import dayjs from 'utils/dayjs-duration';
import { Modal, ModalBody, ModalFooter, ModalHeader, Text, Alert, Button, Flex, } from '@spothero/ui';
const CancellationAlert = ({ cancellationMinutes }) => {
    const [openModal, setOpenModal] = useState(false);
    const displayCancellationMinutes = cancellationMinutes
        ? dayjs.duration(cancellationMinutes, 'minutes').asHours()
        : 0;
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    if (!cancellationMinutes) {
        return null;
    }
    return (<>
            <Alert data-testid="cancellation-alert" paddingY={4} description={<>
                        Free cancellation up to {displayCancellationMinutes}{' '}
                        hours before reservation starts.{' '}
                        <Button variant="tertiary" onClick={() => setOpenModal(true)} fontSize="sm" textDecoration="underline">
                            Learn more
                        </Button>
                    </>}/>
            <Modal onClose={handleCloseModal} isOpen={openModal} size="sm-md" hasHeader hasFooter>
                <ModalHeader>Free Cancellation Policy</ModalHeader>
                <ModalBody>
                    <Flex gap={4} flexDirection="column">
                        <Text>
                            This reservation can be cancelled up to
                            {displayCancellationMinutes} hours before the
                            reservation start time for a full refund. You can
                            cancel your reservation on the Spothero website or
                            app.
                        </Text>
                        <Text>
                            If you&apos;re having trouble with your reservation
                            and it&apos;s after the start time, please reach out
                            to our Customer Heroes who are more than happy to
                            help rectify any situation!
                        </Text>
                    </Flex>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={handleCloseModal}>Okay</Button>
                </ModalFooter>
            </Modal>
        </>);
};
export default CancellationAlert;
